import { NgClass } from '@angular/common';
import { Component, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { IntegracaoConstants } from 'src/app/constants/integracao';
import { BottomSheetComponent } from '../bottom-sheet/bottom-sheet.component';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { heroChevronLeft, heroChevronRight, heroListBullet, heroPlus, heroRectangleGroup } from '@ng-icons/heroicons/outline';

type NavbarItem = {
  id: number;
  icon: string;
  txt: string;
  route?: string;
  isNovaCotacao?: boolean;
  isActivated?: boolean;
}

@Component({
    selector: 'app-navbar-mobile',
    imports: [NgClass, BottomSheetComponent, NgIcon],
    providers: [provideIcons({heroChevronRight, heroChevronLeft, heroListBullet, heroRectangleGroup, heroPlus})],
    templateUrl: './navbar-mobile.component.html',
    styleUrl: './navbar-mobile.component.scss'
})
export class NavbarMobileComponent implements OnInit {

  constructor(private router: Router) {}

  protected readonly navbarItems: NavbarItem[] = [
    {
      id: 1,
      icon: 'heroListBullet',
      txt: "Cotações",
      route: '/cotacoes',
      isActivated: true
    },
    {
      id: 2,
      icon: 'heroPlus',
      txt: "Nova cotação",
      isNovaCotacao: true
    },
    {
      id: 3,
      icon: 'heroRectangleGroup',
      txt: "Dashboard",
      route: '/dashboard',
    }
  ]

  protected showBottomSheetRamos: boolean = false;

  protected gruposRamos = IntegracaoConstants.gruposRamos({removeOpcoesDeTodos: true});
  protected showRamosDoGrupoSelecionado: boolean = false;
  protected grupoRamoSelecionado;

  ngOnInit(): void {
    this.verificaRotaAtual();
  }

  private verificaRotaAtual = () => {
    const hrefSplitted = location.href.split('/');
    const rotaAtual = hrefSplitted[hrefSplitted.length - 1];

    this.navbarItems.some(item => {
      item.isActivated = item.route === `/${rotaAtual}`;
    })
  }

  protected handleClickItem = (clickedItem: NavbarItem, event: Event) => {
    event.stopPropagation();

    if (clickedItem.isNovaCotacao) {
      this.showBottomSheetRamos = true;
      return;
    }

    this.navigateToRoute(clickedItem.route);
    this.navbarItems.forEach(item => item.isActivated = item.id === clickedItem.id);
  }

  private navigateToRoute = (route?: string, formulario?: boolean) => {

    if (formulario) {
      this.showBottomSheetRamos = false;
      this.grupoRamoSelecionado = null; this.showRamosDoGrupoSelecionado = false;
    }
    
    this.router.navigate([route]);
  }

  protected handleClickGrupoRamo = (grupoRamo, event: Event) => {
    event.stopPropagation();
    if (!grupoRamo.subRamos) {return};
    this.grupoRamoSelecionado = grupoRamo;
    this.showRamosDoGrupoSelecionado = true;
  }

  protected handleClickRamo = (ramoItem) => {
    const {formularioURL} = ramoItem;
    this.navigateToRoute(formularioURL, true);
  }

  protected handleVoltarGruposRamos = (event: Event) => {
    event.stopPropagation();

    // Espera 300ms até a animação terminar. Sem o timeout, os ramos do grupo selecionado somem e fica muito estranho. 
    this.showRamosDoGrupoSelecionado = false;
    setTimeout(() => {
      this.grupoRamoSelecionado = null;
    }, 300);
  }
}
